import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, ref } from "vue";
import { useRoute,useRouter } from "vue-router";
import Paginator from "../service/PaginatorService";
import {useDisplay} from "vuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationComponent',
  props: {paginatorData: {required: true, type: Paginator}, nav:{type:Boolean, default: true}, limit: Number},
  emits: ['pageChange'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const limitRef = ref<any>(props.limit);
const route = ref<any>(useRoute());
const router = ref<any>(useRouter());
const display = ref(useDisplay());
const isActiveMobileDevice = ref(display.value.mobile);

watch(() => props.paginatorData.currentPage,async () => {
    emit('pageChange', props.paginatorData.currentPage);
    if(props.nav) {
      await router.value.push({name: route.value.name,query: Object.assign({}, route.value.query, { page: props.paginatorData.currentPage})});
    } else {
      props.paginatorData.doCalculations();
      props.paginatorData.routeFunc();
    }
});

watch(() => display.value, () => {
  isActiveMobileDevice.value = display.value.mobile;
})


return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createBlock(_component_v_pagination, {
    density: "compact",
    modelValue: props.paginatorData.currentPage,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.paginatorData.currentPage) = $event)),
    length: Math.ceil(props.paginatorData.totalCount / props.paginatorData.itemsPerPage ),
    "total-visible": 3,
    border: "",
    "active-color": "black",
    color: "black",
    "show-first-last-page": "",
    "first-aria-label": "First",
    rounded: "0"
  }, null, 8 /* PROPS */, ["modelValue", "length"]))
}
}

})